function resize(visual, offsetEl, offset) {
    visual.style.left = `${offsetEl.getBoundingClientRect().right - offset}px`;
    visual.style.width = `calc(100% - ${offsetEl.getBoundingClientRect().right}px + ${offset}px)`;
}

function initVisualBlock(el, offset) {
    const contentBox = el.querySelector('.visual-block__content-box');
    const visual = el.querySelector('.visual-block__visual-holder');
    if (!visual || !contentBox) {
        return;
    }

    resize(visual, contentBox, offset);

    let timeout = null;
    window.addEventListener('resize', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            resize(visual, contentBox, offset);
        }, 100);
    });
}

export default function initVisualBlocks() {
    const elements = document.querySelectorAll('.visual-block');
    elements.forEach(el => {
        let offset = 0;
        if (el.classList.contains('visual-block--secondary')) {
            offset = 350;
        }
        initVisualBlock(el, offset);
    });
}
